/* LA PORTE DES OPÉRATIONS (2026-09-29). Le rôle Opérations (périmètre
   `sales`) n'a pas la finance : ses écrans d'Opérations (Investissements,
   Charges directes, variables et fixes) passent par `/api/sop`, où le serveur
   ne sert qu'une liste blanche. Quiconque lit la finance garde ses routes
   `/api/financials`. App pose le choix une fois, à partir des droits de la
   personne connectée ; les modules d'API le lisent à chaque appel. */
let viaSop = false;

export const setOpsViaSop = (v) => { viaSop = !!v; };
export const opsViaSop = () => viaSop;
